import React from 'react';
import { useCarousel } from '../common/landingHooks';

const ChevronL = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const ChevronR = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;

const QUOTES = [
    { q: "That's the minimum requirement for a data room — it helps me follow that structure and have it all in one place. Probably enough to start due diligence with an investor.", a: '— CEO, AI startup, active £1.5M seed round' },
    { q: 'A living, breathing data room that syncs with SharePoint to maintain continuous readiness.', a: '— Founder, medtech company' },
    { q: 'Proactive organisation to secure a higher valuation and prevent last-minute price chipping.', a: '— Advisor, company preparing for sale (April 2026)' },
    { q: "Putting a deal in front of a VC with the Diligentsia outputs alongside the deck. You've answered 60 questions they didn't even ask yet.", a: '— Fractional CFO, Diligentsia investor' },
    { q: "If you don't have a good data room — people get all hot and excited. And then they lose interest rapidly.", a: '— MD, accelerator incubator (May 2026)' },
];

const GLOWS = [
    { top: -110, left: -90, size: 480, c: 'rgba(252,119,133,0.42)' },
    { top: 20, right: -120, size: 540, c: 'rgba(74,103,255,0.40)' },
    { bottom: -150, left: '12%', size: 520, c: 'rgba(74,103,255,0.34)' },
    { bottom: -110, right: '6%', size: 420, c: 'rgba(252,119,133,0.32)' },
];

const pos = (v) => (v == null ? 'auto' : typeof v === 'number' ? v + 'px' : v);

const HomeTestimonials = () => {
    const { viewportRef, trackRef, page, pages, next, prev, goTo, pause, resume } = useCarousel(QUOTES.length, { autoplayMs: 5500 });

    return (
        <section className="lp-quotes">
            <div className="lp-quotes-bg" aria-hidden="true">
                {GLOWS.map((g, i) => (
                    <i key={i} style={{ top: pos(g.top), bottom: pos(g.bottom), left: pos(g.left), right: pos(g.right), width: g.size + 'px', height: g.size + 'px', background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`, filter: 'blur(78px)' }} />
                ))}
            </div>

            <div className="lp-sec-head">
                <div>
                    <div className="lp-quotes-eyebrow" data-lp-reveal>What they say.</div>
                    <h2 className="lp-h2" data-lp-reveal>Trusted by investors, advisors, and companies.</h2>
                    <p className="lp-quotes-sub" data-lp-reveal>Voices from across the Diligentsia ecosystem.</p>
                </div>
                <div className="lp-arrows">
                    <button className="lp-arrow" aria-label="Previous quotes" onClick={prev}><ChevronL /></button>
                    <button className="lp-arrow" aria-label="Next quotes" onClick={next}><ChevronR /></button>
                </div>
            </div>

            <div className="lp-viewport" onMouseEnter={pause} onMouseLeave={resume}>
                <div className="lp-vp-inner" ref={viewportRef}>
                    <div className="lp-slide-anim">
                        <div className="lp-track" ref={trackRef}>
                            {QUOTES.map((item, i) => (
                                <figure className="lp-qcard" key={i} data-lp-reveal data-lp-delay={(i % 3) * 120}>
                                    <div className="mark">“</div>
                                    <blockquote>{item.q}</blockquote>
                                    <figcaption>{item.a}</figcaption>
                                </figure>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="lp-foot">
                <p data-lp-reveal>Real feedback from founders, advisors, and investors using Diligentsia.</p>
                <div className="lp-dots" style={{ margin: 0, padding: 0 }}>
                    {Array.from({ length: pages }).map((_, i) => (
                        <button key={i} className={`lp-dot ${i === page ? 'is-active' : ''}`} aria-label={`Go to slide ${i + 1}`} onClick={() => goTo(i)} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeTestimonials;
